import sample_01 from './polar.jpg';

export const polarImpressions = {
    sample_01,
};
